import omit from 'lodash/omit';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import isEqual from 'lodash/isEqual';
import { getApptrackDetails } from 'store/appTrack/actions';
import { instance } from 'store/utils';
import { types } from './types';
import { redirectUrl , toFileFromBase64 , guessMimeType} from 'utils';
import { downloadFile, downloadRequestHeaders } from './utils';
import { triggerNotification } from 'components';

export const react_path = process.env.REACT_APP_PROCESS_APP;

export const parseExcel = params => dispatch => {
  dispatch({ type: types.PARSE_EXCEL.START });
  instance
    .get(`/app/rest/process-instances/excel/v1/${params.id}`)
    .then(response => {
      dispatch({ type: types.PARSE_EXCEL.SUCCESS, payload: response.data });
      dispatch(
        getProjectPlanInfo(
          response.data.abiVat,
          //response.data.investmentPlanElements.addedSchema
        )
      );
      params.callback(true);
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({
        type: types.PARSE_EXCEL.ERROR,
        payload: { name: params.name },
      });
      params.callback(false);
    });
};

export const sendReguests = (taskId, files = []) => async (dispatch) => {
  dispatch({ type: types.GET_EQUIPMENT_REQUESTS.START });

  try {
    const form = new FormData();

    // You can only send ONE file per field because the controller takes a single MultipartFile per param.
    // If you ever need multiple, change the controller to MultipartFile[].
    const firstOfType = { fileForUpdate: null, fileForDeletion: null };

    for (const f of files) {
      if (!f || !f.type || !f.content) continue;
      if (f.type !== 'fileForUpdate' && f.type !== 'fileForDeletion') continue;
      if (firstOfType[f.type]) continue; // keep only the first per type

      const file = toFileFromBase64(
        f.content,
        f.filename || 'upload.bin',
        f.mimeType || guessMimeType(f.filename)
      );

      form.append(f.type, file, file.name); // field name MUST match @RequestParam
      firstOfType[f.type] = true;
    }

    // If your axios instance sets JSON by default, override Content-Type:
    const res = await instance.post(
      `app/rest/tasks/${taskId}/equipment-request`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } } // or omit and let axios set it
    );

    // Controller returns void; res.data may be undefined—that’s fine.
    dispatch({ type: types.GET_EQUIPMENT_REQUESTS.SUCCESS, payload: res?.data });
    triggerNotification({mode:'REQUESTS'});
  } catch (error) {
    console.error('createEquipmentRequest error:', error);
    dispatch({ type: types.GET_EQUIPMENT_REQUESTS.ERROR });
  }
};


export const  getRequests = taskId => dispatch =>  {
  dispatch({ type: types.GET_REQUESTS.START });
  instance
    .get(`/app/rest/tasks/${taskId}/equipment-requests`)
    .then(response => {
      dispatch({
        type: types.GET_REQUESTS.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_REQUESTS.ERROR });
    });
};

export const getAppConfig = taskid => dispatch => {
  dispatch({ type: types.GET_APP_CONFIG.START });
  instance
    // .get('/login/oauth2/code/'+process.env.REACT_APP_AUTH2_CLIENT)
    .get('/oauth2/authorization/'+process.env.REACT_APP_AUTH2_CLIENT)
    .then(response => {
      console.log("respo", response);
      dispatch({
        type: types.GET_APP_CONFIG.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      console.error("error", error);
      dispatch({ type: types.GET_APP_CONFIG.ERROR });
    });
};


export const getByCode = () => dispatch => {
  dispatch({ type: types.GET_BY_CODE.START });
  instance
    .get('/app/rest/configurations/getByCode?code=acceptedKads')
    .then(response => {
      dispatch({
        type: types.GET_BY_CODE.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_BY_CODE.ERROR });
    });
};

export const kadBranchesService = (afm, currentDate) => dispatch => {
  dispatch({ type: types.GET_KAD_BRANCHES.START });
  instance
    .get(`/app/rest/kadBranches?dateFrom=${currentDate}&dateTo=${currentDate}&afm=${afm}`)
    .then(response => {
      dispatch({
        type: types.GET_KAD_BRANCHES.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_KAD_BRANCHES.ERROR });
    });
};

export const ibanAfmValidation = (iban,afm) => dispatch => {
  dispatch({ type: types.GET_IBAN_VALIDATION.START });
  instance
    .get(`/app/rest/account/ibanAfmValidation?iban=${iban}&afm=${afm}`)
    .then(response => {
      dispatch({
        type: types.GET_IBAN_VALIDATION.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ 
        type: types.GET_IBAN_VALIDATION.ERROR,
        payload: error.response.data,
       });
    });
};

export const ibanAfmValidationWithBank = (iban,afm,swiftBIC, processInstanceId) => dispatch => {
  dispatch({ type: types.GET_IBAN_VALIDATION_WITH_BANK.START });
  instance
    .get(`/app/rest/process-instances/${processInstanceId}/ibanAfmValidationWithBank?iban=${iban}&swiftBIC=${swiftBIC}&vat=${afm}`)
    .then(response => {
      dispatch({
        type: types.GET_IBAN_VALIDATION_WITH_BANK.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      console.log("ERROR", error.response)
      dispatch({ 
        type: types.GET_IBAN_VALIDATION_WITH_BANK.ERROR,
        payload: error.response.data,
       
      });
    });
};

export const updateIbanDetails = (processInstanceId, payload) => dispatch => {
  dispatch({ type: types.UPDATE_IBAN.START });
  dispatch(triggerLoading(true));
  instance
    .put(`/app/rest/updateIban/${processInstanceId}`, payload)
    .then((response) => {
      dispatch({
        type: types.UPDATE_IBAN.SUCCESS,
        payload: response.data,
      });
      dispatch(getMainformDetails(processInstanceId));
      dispatch(triggerLoading(false));
    })
    .catch(error => {
      dispatch({ 
        type: types.UPDATE_IBAN.ERROR,
        payload: error?.response   
      });
      dispatch(triggerLoading(false));
    });
};

export const getFormData = taskId => dispatch => {
  dispatch({ type: types.GET_FORM_DATA.START });
  instance
    .get(`/app/rest/task-forms/${taskId}/with-vars`)
    .then(response => {
      dispatch({ type: types.GET_FORM_DATA.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_FORM_DATA.ERROR });
    });
};

export const getFormUploads = taskId => dispatch => {
  dispatch({ type: types.GET_FORM_UPLOADS.START });
  instance
    .get(`/app/rest/tasks/${taskId}/content`)
    .then(response => {
      dispatch({
        type: types.GET_FORM_UPLOADS.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_FORM_UPLOADS.ERROR });
    });
};

export const getTaskData = taskId => dispatch => {
  dispatch({ type: types.GET_TASK_DATA.START });
  instance
    .get(`/app/rest/tasks/${taskId}`)
    .then(response => {
      dispatch({ type: types.GET_TASK_DATA.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_TASK_DATA.ERROR });
    });
};

export const startNew = (navigate, isForeign) => dispatch => {
  dispatch({ type: types.START_NEW.START });
  instance
    .get(`/app/rest/startnew?appDefinitionKey=${react_path}`)
    .then(response => {
      dispatch({ type: types.START_NEW.SUCCESS, payload: response.data });
      isForeign ? navigate(`/main-forms-fs/${response.data.taskId}`) : navigate(`/main-forms/${response.data.taskId}`);
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.START_NEW.ERROR });
    });
};

export const claimActive = (navigate, processInstanceId, view , user, isForeignSupplier) => dispatch => {
  console.log("user has :",user)
  dispatch({ type: types.CLAIM_ACTIVE.START });
  instance
    .get(`/app/rest/tasks/${processInstanceId}/action/claim-active`)
    .then(response => {
      dispatch({ type: types.CLAIM_ACTIVE.SUCCESS, payload: response.data });
      user === "beneficiary" ?
        view ? navigate(`/apptrack/${response.data.taskId}`) : navigate(`/main-forms/${response.data.taskId}`)
        : user === "foreign" ?
            view ? navigate(`/apptrack/${response.data.taskId}`) : navigate(`/main-forms-fs/${response.data.taskId}`)
          : user === "auditor" ?
            !isForeignSupplier ?
              view ? navigate(`/apptrack/${response.data.taskId}`) : navigate(`/main-forms-auditor/${response.data.taskId}`) 
            : view ? navigate(`/apptrack/${response.data.taskId}`) : navigate(`/main-forms-auditor-fs/${response.data.taskId}`) 
          : !isForeignSupplier ?
              view ? navigate(`/apptrack/${response.data.taskId}`) : navigate(`/main-forms-oc/${response.data.taskId}`)
              : view ? navigate(`/apptrack/${response.data.taskId}`) : navigate(`/main-forms-oc-fs/${response.data.taskId}`) 

    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.CLAIM_ACTIVE.ERROR });
    });
};

export const claimActiveViewMode = (navigate, processInstanceId) => dispatch => {
  dispatch({ type: types.CLAIM_ACTIVE_VIEW_MODE.START });
  instance
    .get(`/app/rest/tasks/${processInstanceId}/action/claim-active`)
    .then(response => {
      dispatch({ type: types.CLAIM_ACTIVE_VIEW_MODE.SUCCESS, payload: response.data });
      navigate(`/main-forms/${response.data.taskId}/view`)
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.CLAIM_ACTIVE_VIEW_MODE.ERROR });
    });
};

export const getProcessInstances = params => dispatch => {
  dispatch({ type: types.GET_PROCESS_INSTANCES.START });
  instance
    .get(`/app/rest/process-instance-apptrack-detailed/${params.processInstanceId}`)
    .then(response => {
      dispatch({
        type: types.GET_PROCESS_INSTANCES.SUCCESS,
        payload: {
          variables: {
            ...response.data.variablesIndexed,
          },
          content: response.data.contentItems,
          businessKey: response.data.businessKey,
          id: response.data.id,
          activeTaskName: response.data.activeTaskName,
        },
      });
      if(!params.isViewMode){
      dispatch(getFormData(params.taskId));
      }
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_PROCESS_INSTANCES.ERROR });
    });
};

export const openUploadedFile = file => dispatch => {
  dispatch({ type: types.OPEN_UPLOADED_FILE.START });
  instance
    .get(`app/rest/content/${file.id}/download`, downloadRequestHeaders)
    .then(response => {
      if(file.simpleType === 'pdf'){
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        window.open(url);
        dispatch({
          type: types.OPEN_UPLOADED_FILE.SUCCESS,
        });
      }else{
        downloadFile({ response, file });
        dispatch({
          type: types.OPEN_UPLOADED_FILE.SUCCESS,
        });
      }
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.OPEN_UPLOADED_FILE.ERROR });
    });
};

export const downloadUploadedFile = file => dispatch => {
  dispatch({ type: types.DOWNLOAD_UPLOADED_FILE.START });
  instance
    .get(`/app/rest/content/${file.id}/download`, downloadRequestHeaders)
    .then(response => {
      downloadFile({ response, file });
      dispatch({
        type: types.DOWNLOAD_UPLOADED_FILE.SUCCESS,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.DOWNLOAD_UPLOADED_FILE.ERROR });
    });
};

export const downloadUploadedFileEquipement = file => dispatch => {
  dispatch({ type: types.DOWNLOAD_UPLOADED_FILE_EQUIPEMENT.START });
  instance
    .get(`app/rest/equipment-documents/${file.id}/file`, downloadRequestHeaders)
    .then(response => {
      downloadFile({ response, file });
      dispatch({
        type: types.DOWNLOAD_UPLOADED_FILE_EQUIPEMENT.SUCCESS,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.DOWNLOAD_UPLOADED_FILE_EQUIPEMENT.ERROR });
    });
};

export const getOtp = params => dispatch => {
  console.log('params: ', params)
  dispatch({ type: types.GET_OTP.START });
  instance
    .get(`app/rest/otp/${params.processInstanceId}/new?${params.fieldName}=${params.fieldValue}`)
    .then(response => {
      console.log('response:', response)
      dispatch({
        type: types.GET_OTP.SUCCESS,
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ 
        type: types.GET_OTP.ERROR,
        payload: {
          getOtpError: true,
      } 
      });
      dispatch({ type: types.GET_OTP.ERROR });
    });
};

export const validateOtp = (params) => dispatch => {
  console.log('validateOtp params: ', params)

  // const parameters = {
  //   otp: params.otp,
  //   comms: params.fieldValue
  // } 

  dispatch({ type: types.VALIDATE_OTP.START });
  instance
    .post(`app/rest/otp/${params.processInstanceId}/validate?otp=${params.otp}&comms=${params.fieldValue}`)
    .then(response => {
      console.log('response:', response)
      dispatch({
        type: types.VALIDATE_OTP.SUCCESS,
        payload: {
          variables: response.data,
          field: params.field,
          otpError: false,
        }
      });
      return true;
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ 
        type: types.VALIDATE_OTP.ERROR,
        payload: {
          otpError: true,
      } 
      });
      return false;
    });
};

// Post actions

export const saveTask = params => dispatch => {
  dispatch({ type: types.SAVE_TASK.START });
  instance
    .post(
      `/app/rest/task-forms/${params.taskId}/save-task-form`,
      omit(params, ['taskId'])
    )
    .then(() => {
      dispatch({ type: types.SAVE_TASK.SUCCESS });
      triggerNotification({mode:'ERROR'});
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.SAVE_TASK.ERROR });
    });
};

export const submitTask = params => dispatch => {
  dispatch({ type: types.SUBMIT_TASK.START });
  dispatch(triggerLoading(true));
  instance
    .post(
      `/app/rest/task-forms/${params.taskId}/extended`,
      omit(params, [
        'taskId',
      ])
    )
    .then(() => {
      dispatch({ type: types.SUBMIT_TASK.SUCCESS });
      dispatch(triggerLoading(false));
      params.navigate("/appTrack");
      
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch(triggerLoading(false));
      dispatch({ type: types.SUBMIT_TASK.ERROR, payload: error.response });
    });
};


export const submitTaskCarriers = params => dispatch => {
  let payload = params.values.carrierUsers;
  dispatch({ type: types.SUBMIT_CARRIER_USERS.START });
  dispatch(triggerLoading(true));
  instance
    .post(
      `/app/rest/carrier-users/${params.taskId}`,payload)
    .then(() => {
      dispatch({ type: types.SUBMIT_CARRIER_USERS.SUCCESS });
      dispatch(triggerLoading(false));
      params.navigate("/appTrack");
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch(triggerLoading(false));
      dispatch({ type: types.SUBMIT_CARRIER_USERS.ERROR, payload: error.response });
    });
};


export const approveAudit = taskId => async dispatch => {
  dispatch({ type: types.APPROVE_AUDIT.START });
  dispatch(triggerLoading(true));
  return await instance
    .post(`/app/rest/task-forms/${taskId}/approveAudit`)
    .then((response) => {
      dispatch({ type: types.APPROVE_AUDIT.SUCCESS });
      dispatch(triggerLoading(false));
      window.location.href = redirectUrl;
      return response;
    })
    .catch(error => {
      dispatch({ type: types.APPROVE_AUDIT.ERROR });
      dispatch(triggerLoading(false));
    });
}

export const rejectAudit = (params) => async dispatch => {
  dispatch({ type: types.REJECT_AUDIT.START });
  dispatch(triggerLoading(true));
  const payload = params.reject;
      
  return await instance
    .post(`/app/rest/task-forms/${params.taskId}/rejectAudit`, payload)
    .then((response) => {
      dispatch({ type: types.REJECT_AUDIT.SUCCESS });
      dispatch(triggerLoading(false));
      window.location.href = redirectUrl;
      return response
    })
    .catch(error => {
      dispatch({ type: types.REJECT_AUDIT.ERROR });
      dispatch(triggerLoading(false));
    });
}

export const approveObjection = taskId => async dispatch => {
  dispatch({ type: types.APPROVE_OBJECTION.START });
  dispatch(triggerLoading(true));
  return await instance
    .post(`/app/rest/task-forms/${taskId}/approveObjection`)
    .then((response) => {
      dispatch({ type: types.APPROVE_OBJECTION.SUCCESS });
      dispatch(triggerLoading(false));
      window.location.href = redirectUrl;
      return response;
    })
    .catch(error => {
      dispatch({ type: types.APPROVE_OBJECTION.ERROR });
      dispatch(triggerLoading(false));
    });
}

export const rejectObjection = (params) => async dispatch => {
  dispatch({ type: types.REJECT_OBJECTION.START });
  dispatch(triggerLoading(true));
  const payload = params.reject;
      
  return await instance
    .post(`/app/rest/task-forms/${params.taskId}/rejectObjection`, payload)
    .then((response) => {
      dispatch({ type: types.REJECT_OBJECTION.SUCCESS });
      dispatch(triggerLoading(false));
      window.location.href = redirectUrl;
      return response
    })
    .catch(error => {
      dispatch({ type: types.REJECT_OBJECTION.ERROR });
      dispatch(triggerLoading(false));
    });
}


export const rejectTask = params => dispatch => {
  dispatch({ type: types.REJECT_TASK.START });
  const payload = !isEmpty(params.reject)
    ? params.reject
    : {
        message: params.message,
        reason: params.reason,
        nextProcessStatusCode: params.nextProcessStatusCode,
      };
  instance
    .post(`/app/rest/tasks/${params.taskId}/comments-extended`, payload)
    .then(() => {
      dispatch({ type: types.REJECT_TASK.SUCCESS });
      dispatch(submitTask({ ...params }));
    })
    .catch(error => {
      dispatch({ type: types.REJECT_TASK.ERROR });
    });
};

export const checkUniqueness = params => async dispatch => {
  dispatch({ type: types.CHECK_UNIQUENESS.START });
  return await instance
    .post(
      `/app/rest/check-uniqueness`,params)
    .then(response => {
      dispatch({ type: types.CHECK_UNIQUENESS.SUCCESS });
      return response.data;
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.CHECK_UNIQUENESS.ERROR });
    });
};

export const thirdPartyValidations = params => async dispatch => {
  dispatch({ type: types.THIRD_PARTY_VALIDATIONS.START });
  return await instance
    .post(
      `/app/rest/validation/third-party-validations`,params)
    .then(response => {
      dispatch({ type: types.THIRD_PARTY_VALIDATIONS.SUCCESS });
      return response.data;
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.THIRD_PARTY_VALIDATIONS.ERROR });
    });
};

export const getProjectPlanInfo = (afm, mainKAD, enterpriseSize, aidAmount, addedSchema) => async dispatch => {
  dispatch({ type: types.GET_PROJECT_PLAN_INFO.START });
  return await instance
  .post(`/app/projectPlanInfo`, { afm: afm, kad: mainKAD, enterpriseSize:enterpriseSize, aidAmount: aidAmount })
    .then(response => {
      if (!isEmpty(response.data)) {
        if (find(response.data.messages.message, { messageCode: -4 })) {
          dispatch(sorefsisError(false));
        } else if (find(response.data.messages.message, { messageCode: -1 })) {
          dispatch(sorefsisError(false));
        } else {
          if (
            isEqual(
              addedSchema,
              'Το επενδυτικό σχέδιο δεν έχει ενταχθεί σε κάποιο καθεστώς ενίσχυσης'
            )
          ) {
            dispatch(sorefsisError(true));
            dispatch(setValidity({ group: 'sorefsis', value: false }));
          } else {
            dispatch(sorefsisError(false));
            dispatch(setValidity({ group: 'sorefsis', value: true }));
          }
        }
      }
      dispatch({
        type: types.GET_PROJECT_PLAN_INFO.SUCCESS,
        payload: response.data,
      });
      return response.data;
    })
    .catch(error => {
      dispatch({ type: types.GET_PROJECT_PLAN_INFO.ERROR });
      console.log(error, 'error');
    });
};

// Helper actions

export const updateFormField = payload => dispatch => {
  dispatch({ type: types.UPDATE_FORM_FIELD_FORMS, payload });
};

export const updateOneFormField = payload => dispatch => {
  dispatch({ type: types.UPDATE_ONE_FORM_FIELD_FORMS, payload });
};

export const deleteDocument = payload => dispatch => {
  dispatch({ type: types.DELETE_DOCUMENT.START });
  instance
  .delete(
    `/app/rest/file/${payload?.docId}`)
  .then(response => {
    dispatch({ type: types.DELETE_DOCUMENT.SUCCESS });
  })
  .catch(error => {
    console.log(error, 'error');
    dispatch({ type: types.DELETE_DOCUMENT.ERROR });
  });
}

export const clearForm = () => dispatch => {
  dispatch({ type: types.CLEAR_FORM.SUCCESS });
};

export const clearAdvisorFields = () => dispatch => {
  dispatch({ type: types.CLEAR_ADVISOR_FIELDS });
};

export const setValidity = payload => dispatch => {
  dispatch({ type: types.UPDATE_FORM_VALIDITY, payload });
};

export const triggerLoading = payload => dispatch => {
  dispatch({ type: types.TRIGGER_LOADING, payload });
};

export const clearExcelData = () => dispatch => {
  dispatch({ type: types.CLEAR_EXCEL_DATA });
};

export const clearExcelError = () => dispatch => {
  dispatch({ type: types.CLEAR_EXCEL_ERROR });
};

export const sorefsisError = payload => dispatch => {
  dispatch({ type: types.SOREFSIS_ERROR, payload });
};

export const updateBusinessPlanExpense = payload => dispatch => {
  dispatch({ type: types.UPDATE_BUSINESS_PLAN_EXPENSE });
};

export const getSystemLocales = (countryCode) => (dispatch) => {
  dispatch({ type: types.LOAD_SYSTEM_LOCALES.START }); // Start loading locales
  instance
    .get(`/localStrings/${countryCode}`)
    .then((response) => {
      dispatch({ type: types.LOAD_SYSTEM_LOCALES.SUCCESS, payload: response.data });
    })
    .catch((error) => {
      dispatch({ type: types.LOAD_SYSTEM_LOCALES.ERROR });
    });
};

export const getMainformDetails = (processInstanceId) => dispatch => {
  dispatch({ type: types.GET_MAINFORM_DETAILS.START });
  dispatch(triggerLoading(true));
  instance
    .get(`/app/rest/process-instance-apptrack-detailed/${processInstanceId}`)
    .then((response) => {
      dispatch({
        type: types.GET_MAINFORM_DETAILS.SUCCESS,
        payload: {
          activeTaskName: response.data.activeTaskName,
          businessKey: response.data.businessKey,
          localTaskVariables: response.data.localTaskVariables,
          variablesIndexed: response.data.variablesIndexed,
          contentItems: response.data.contentItems,
          comments: response.data.comments,
        },
      });
      dispatch(triggerLoading(false));
    })
    .catch(error => {
      dispatch({ type: types.GET_MAINFORM_DETAILS.ERROR });
      dispatch(triggerLoading(false));
      console.log(error, 'error');
    });
}


//for build tk lookup
export const getTaxisDataByTk = tk => dispatch => {
  dispatch({ type: types.GET_TAXIS_DATA_BY_TK.START });
  instance
    .get(`/app/rest/account/findInfoByZip/${tk}`)
    .then(response => {
      //dummy tk return
      const results = [
        {
            "code": 26441,
            "area": "ΠΑΤΡΑ",
            "description": "ΠΑΤΡΑ",
            "nomos": "Ν. ΑΧΑΪΑΣ",
            "zipCode": "26441"
        },
        {
          "code": 26441,
          "area": "ΖΩΓΡΑΦΟΥ",
          "description": "ΖΩΓΡΑΦΟΥ",
          "nomos": "Ν. ΑΤΤΙΚΗΣ",
          "zipCode": "26441"
      },
      ]
      console.log(response.data);
      dispatch({
        type: types.GET_TAXIS_DATA_BY_TK.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_TAXIS_DATA_BY_TK.ERROR });
    });
};


//for abi tk lookup
export const getTaxisDataByAbiTK = tk => dispatch => {
  dispatch({ type: types.GET_TAXIS_DATA_BY_ABI_TK.START });
  instance
    .get(`/app/rest/account/findInfoByZip/${tk}`)
    .then(response => {
      //dummy tk return
      const results = [
        {
            "code": 26441,
            "area": "ΠΑΤΡΑ",
            "description": "ΠΑΤΡΑ",
            "nomos": "Ν. ΑΧΑΪΑΣ",
            "zipCode": "26441"
        },
        {
          "code": 26441,
          "area": "ΖΩΓΡΑΦΟΥ",
          "description": "ΖΩΓΡΑΦΟΥ",
          "nomos": "Ν. ΑΤΤΙΚΗΣ",
          "zipCode": "26441"
      },
      ]
      console.log(response.data);
      dispatch({
        type: types.GET_TAXIS_DATA_BY_ABI_TK.SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      dispatch({ type: types.GET_TAXIS_DATA_BY_ABI_TK.ERROR });
    });
};


export const submitConsentAuditor = params => dispatch => {
  dispatch({ type: types.SUBMIT_CONSENT.START });
  instance
    .post(`/app/rest/${params.taskId}/auditor-consent`, {
      consent: params.consent,
    })
    .then(response => {
      dispatch({ type: types.SUBMIT_CONSENT.SUCCESS, payload: response.data });
      if(params.consent){
        params.isForeignSupplier ? 
          params.navigate(`/main-forms-auditor-fs/${response.data.activeTaskId}`) : 
          params.navigate(`/main-forms-auditor/${response.data.activeTaskId}`);
      }
      if (!params.consent) {
        params.navigate("/appTrack");
      }
    })
    .catch(error => {
      dispatch({ type: types.SUBMIT_CONSENT.ERROR });
    });
};


export const submitConsentObjection = params => dispatch => {
  dispatch({ type: types.SUBMIT_CONSENT.START });
  instance
    .post(`/app/rest/${params.taskId}/auditor-consent`, {
      consent: params.consent,
    })
    .then(response => {
      dispatch({ type: types.SUBMIT_CONSENT.SUCCESS, payload: response.data });
      if(params.consent){
        params.isForeignSupplier ? 
          params.navigate(`/main-forms-oc-fs/${response.data.activeTaskId}`) :
          params.navigate(`/main-forms-oc/${response.data.activeTaskId}`)
      }
      if (!params.consent) {
        params.navigate("/appTrack");
      }
    })
    .catch(error => {
      dispatch({ type: types.SUBMIT_CONSENT.ERROR });
    });
};


export const updateRequestStatus = (taskId,status,comment) => dispatch => {
  dispatch({ type: types.UPDATE_REQUEST_STATUS.START });
  instance
    .put(`app/rest/tasks/${taskId}/equipment-request/status`, {
      status: status,
      comment:comment
    })
    .then(response => {
      dispatch({ type: types.UPDATE_REQUEST_STATUS.SUCCESS, payload: response.data });
      dispatch(getRequests(taskId));
    })
    .catch(error => {
      console.log('Error: ', error)
      dispatch({ type: types.UPDATE_REQUEST_STATUS.ERROR , payload: error?.response });
    });
};
